<template>
  <div class="form__field">
    <div class="form__title" v-show="field.title">{{ field.title }}</div>
    <div class="form__spacer" v-show="field.title"></div>
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <div class="form__control">
      <select
        class="form__select"
        v-model="value"
        :id="identifier"
        :name="identifier"
      >
        <option
          v-for="option in field.options"
          :key="field.name + '-' + option.value"
          :value="option.value"
          :selected="field.value === option.value"
          :disabled="option.disabled"
        >
          {{ option.label }}
        </option>
      </select>
      <span class="form__select__indicator icon-down-open-big"></span>
    </div>
    <div
      class="form__message form__message--joined form__message--error"
      v-show="field.error"
    >
      {{ field.error }}
    </div>
    <div class="form__description" v-show="field.description">
      {{ field.description }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-select"
};
</script>
